import DeveloperLoginLayout from "./developer_login_layout";

const DeveloperLoginPage = () => {
  return (
      <DeveloperLoginLayout />
  );
};

export default DeveloperLoginPage;